/**
 * axios setup to use mock service
 */

import axios, { AxiosRequestConfig } from 'axios';

const axiosServices = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL || 'http://localhost:3333',
  withCredentials: true
});

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('serviceToken');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Partner-facing public routes that bootstrap without a session. A 401 from the
// session probe (`/auth/me`) on these pages must NOT bounce the visitor to /login —
// they are expected to render in a logged-out state.
const PUBLIC_PATH_PREFIXES = ['/h/', '/offer/', '/register/complete/'];

export function shouldRedirectOnUnauthorized(currentPath: string): boolean {
  if (currentPath.startsWith('/login')) return false;
  if (PUBLIC_PATH_PREFIXES.some((prefix) => currentPath.startsWith(prefix))) return false;
  return true;
}

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && shouldRedirectOnUnauthorized(window.location.pathname)) {
      window.location.pathname = '/login';
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;

export async function fetcher(args: string | [string, AxiosRequestConfig]) {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
}
